import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'bloodPressureFormat'
})
export class BloodPressureFormatPipe implements PipeTransform {

  transform(value): any {
    return this.formatBloodPressure(value);
  }

  formatBloodPressure(value) {
    const cleanValue = this.cleanBloodPressure(value);

    let part1 = cleanValue.substr(0, 3);
    let part2 = cleanValue.substr(3, 3);

    return `${part1}${part1.length===3 && part2.length ? '/' : ''}${part2}`
  }

  cleanBloodPressure(value) {
    if (value && value.match(/\d/g) && value.match(/\d/g).length) {
      return value.match(/\d/g).join('');
    }

    return '';
  }
}
